module.exports = window.__loadPromiseRequirejs__("UserFeedbackOpener");